import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "right_cont" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { style: {"width":"100%"} }
const _hoisted_4 = { class: "t6_table_b" }
const _hoisted_5 = { class: "td_center" }
const _hoisted_6 = {
  key: 0,
  class: "pagination"
}
const _hoisted_7 = { style: {"width":"100%"} }
const _hoisted_8 = { class: "t6_table_b" }
const _hoisted_9 = { class: "td_center" }
const _hoisted_10 = {
  key: 0,
  class: "pagination"
}
const _hoisted_11 = { class: "t6_table_b t6_table_b2" }
const _hoisted_12 = { class: "t6_table_b" }
const _hoisted_13 = { class: "td_center" }

import { reactive, ref } from 'vue'
    import { ElMessageBox, TabsPaneContext } from 'element-plus'
    import { apasInfoList, getOnethingDetail, onetThingBussinessList } from '@/config/request'
    
    
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

    const dialog = reactive({
        dialogVisible1: false,
        title1: '详情',
        detail:{} as any,

        dialogVisible2: false,
        title2: '详情',
        onethingDetailsDataList:{} as any,  //  一件事里面的单事项列表
    })

    const activeName = ref('tab1')
    const data = reactive({
        tabDataList1:[] as any,    //  单事项申报列表
        tabDataList2:[] as any,    //  一件事申报列表
    })
    const handleClick = (tab: TabsPaneContext, event: Event) => {
        console.log(tab, event)
    }
    const showDetail1 = (obj:any) => {
        dialog.dialogVisible1 = true
        dialog.title1 = `业务【${obj.servicename}】详情`
        dialog.detail = obj
    }
    const showDetail2 = async(item:any) => {
        const res = await getOnethingDetail({onethingUnid: item.onethingUnid}) as any
        if(res.result.code == 200){
            dialog.dialogVisible2 = true
            dialog.title2 = `一件事【${item.name}】单事项列表`
            dialog.onethingDetailsDataList = res.result.result.preApasinfos;
        }
    }

    const paginate1 = reactive({
        pageNo: 1,
        pageSize: 10,
        pageSizes: [5,10,20],
        total: 0,
    })
    const handleCurrentChange1 = (index:any) => {
        paginate1.pageNo = index
        init()
    }
    const handleSizeChange1 = (index:any) => {
        paginate1.pageSize = index
        init()
    }
    const paginate2 = reactive({
        pageNo: 1,
        pageSize: 10,
        pageSizes: [5,10,20],
        total: 0,
    })
    const handleCurrentChange2 = (index:any) => {
        paginate2.pageNo = index
        init()
    }
    const handleSizeChange2 = (index:any) => {
        paginate2.pageSize = index
        init()
    }

    const init = async() => {
        let param = {
            pageNo: paginate1.pageNo,
            pageSize: paginate1.pageSize,
            nodeName: '',
            handlestate:''
        }
        let res = await apasInfoList(param) as any
        console.log('res---------',res);
        
        let records = res.result?.records
        paginate1.total = res.result?.total
        records.forEach((result: any) => {
            result.createTime = result.createTime.substring(0, 10)
        })
        data.tabDataList1 = records     
        console.log('data.tabDataList1:',data.tabDataList1);

        let param2 = {
            pageNo: paginate2.pageNo,
            pageSize: paginate2.pageSize,
            nodeName: '',
            handlestate:''
        }
        let res2 = await onetThingBussinessList(param2) as any
        let records2 = res2.result?.records
        paginate2.total = res2.result?.total
        records2.forEach((result: any) => {
            result.createTime = result.createTime.substring(0, 10)
        })
        data.tabDataList2 = records2     
        console.log('data.tabDataList2:',data.tabDataList2);
        
    }
    init()

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[19] || (_cache[19] = _createElementVNode("div", { class: "t6_title_h1" }, " 我的办件 ", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("div", null, [
          _createVNode(_component_el_tabs, {
            modelValue: activeName.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeName).value = $event)),
            onTabClick: handleClick
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_tab_pane, {
                label: "单事项",
                name: "tab1"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("table", _hoisted_4, [
                      _cache[4] || (_cache[4] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", { width: "310" }, "办件名称"),
                          _createElementVNode("th", { width: "100" }, "办理状态"),
                          _createElementVNode("th", { width: "220" }, "办件编号"),
                          _createElementVNode("th", { width: "114" }, "申报时间"),
                          _createElementVNode("th", { class: "td_center" }, "操作")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.tabDataList1, (item) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: item.projid
                          }, [
                            _createElementVNode("td", null, _toDisplayString(item.servicename), 1),
                            _createElementVNode("td", null, _toDisplayString(item.handlestate), 1),
                            _createElementVNode("td", null, _toDisplayString(item.projid), 1),
                            _createElementVNode("td", null, _toDisplayString(item.createTime), 1),
                            _createElementVNode("td", _hoisted_5, [
                              _createVNode(_component_el_button, {
                                size: "small",
                                type: "success",
                                onClick: ($event: any) => (showDetail1(item))
                              }, {
                                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                  _createTextVNode("详情", -1)
                                ]))]),
                                _: 1
                              }, 8, ["onClick"])
                            ])
                          ]))
                        }), 128))
                      ])
                    ]),
                    (data.tabDataList1.length === 0)
                      ? (_openBlock(), _createBlock(_component_el_empty, {
                          key: 0,
                          description: "暂无数据"
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  (paginate1.total > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(_component_el_pagination, {
                          background: "",
                          onCurrentChange: handleCurrentChange1,
                          onSizeChange: handleSizeChange1,
                          layout: "sizes, prev, pager, next, ->, total",
                          "page-size": paginate1.pageSize,
                          "page-sizes": paginate1.pageSizes,
                          total: paginate1.total
                        }, null, 8, ["page-size", "page-sizes", "total"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_el_tab_pane, {
                label: "一件事",
                name: "tab2"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("table", _hoisted_8, [
                      _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", { width: "310" }, "办件名称"),
                          _createElementVNode("th", { width: "100" }, "办理状态"),
                          _createElementVNode("th", { width: "220" }, "办件编号"),
                          _createElementVNode("th", { width: "110" }, "申报时间"),
                          _createElementVNode("th", { class: "td_center" }, "操作")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.tabDataList2, (item) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: item.projid
                          }, [
                            _createElementVNode("td", null, _toDisplayString(item.name), 1),
                            _createElementVNode("td", null, _toDisplayString(item.handleState), 1),
                            _createElementVNode("td", null, _toDisplayString(item.onethingUnid), 1),
                            _createElementVNode("td", null, _toDisplayString(item.createTime), 1),
                            _createElementVNode("td", _hoisted_9, [
                              _createVNode(_component_el_button, {
                                size: "small",
                                type: "success",
                                onClick: ($event: any) => (showDetail2(item))
                              }, {
                                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                  _createTextVNode("详情", -1)
                                ]))]),
                                _: 1
                              }, 8, ["onClick"])
                            ])
                          ]))
                        }), 128))
                      ])
                    ]),
                    (data.tabDataList2.length === 0)
                      ? (_openBlock(), _createBlock(_component_el_empty, {
                          key: 0,
                          description: "暂无数据"
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  (paginate2.total > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createVNode(_component_el_pagination, {
                          background: "",
                          onCurrentChange: handleCurrentChange2,
                          onSizeChange: handleSizeChange2,
                          layout: "sizes, prev, pager, next, ->, total",
                          "page-size": paginate2.pageSize,
                          "page-sizes": paginate2.pageSizes,
                          total: paginate2.total
                        }, null, 8, ["page-size", "page-sizes", "total"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_el_dialog, {
        modelValue: dialog.dialogVisible1,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialog.dialogVisible1) = $event)),
        title: dialog.title1,
        width: "80%",
        class: "dialog_content"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createElementVNode("table", _hoisted_11, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _cache[7] || (_cache[7] = _createElementVNode("th", null, "证件类型", -1)),
                  _createElementVNode("td", null, _toDisplayString(dialog.detail.applyCardtype), 1),
                  _cache[8] || (_cache[8] = _createElementVNode("th", null, "证件号码", -1)),
                  _createElementVNode("td", null, _toDisplayString(dialog.detail.applyCardnumber), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[9] || (_cache[9] = _createElementVNode("th", null, "申请人姓名", -1)),
                  _createElementVNode("td", null, _toDisplayString(dialog.detail.applyname), 1),
                  _cache[10] || (_cache[10] = _createElementVNode("th", null, "手机号码", -1)),
                  _createElementVNode("td", null, _toDisplayString(dialog.detail.telphone), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[11] || (_cache[11] = _createElementVNode("th", null, "部门名称", -1)),
                  _createElementVNode("td", null, _toDisplayString(dialog.detail.deptname), 1),
                  _cache[12] || (_cache[12] = _createElementVNode("th", null, "办理节点", -1)),
                  _createElementVNode("td", null, [
                    _createVNode(_component_el_tag, {
                      class: "ml-2",
                      type: "success"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(dialog.detail.handlestate), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _cache[13] || (_cache[13] = _createElementVNode("th", null, "办件类型", -1)),
                  _createElementVNode("td", null, _toDisplayString(dialog.detail.infotype), 1),
                  _cache[14] || (_cache[14] = _createElementVNode("th", null, "查询密码", -1)),
                  _createElementVNode("td", null, _toDisplayString(dialog.detail.projpwd), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[15] || (_cache[15] = _createElementVNode("th", null, "申请时间", -1)),
                  _createElementVNode("td", null, _toDisplayString(dialog.detail.createTime), 1),
                  _cache[16] || (_cache[16] = _createElementVNode("th", null, "申报类型", -1)),
                  _createElementVNode("td", null, _toDisplayString(dialog.detail.applyType), 1)
                ])
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "title"])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_el_dialog, {
        modelValue: dialog.dialogVisible2,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dialog.dialogVisible2) = $event)),
        title: dialog.title2,
        width: "80%",
        class: "dialog_content"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createElementVNode("table", _hoisted_12, [
              _cache[18] || (_cache[18] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { width: "460" }, "办件名称"),
                  _createElementVNode("th", { width: "100" }, "办理状态"),
                  _createElementVNode("th", { width: "180" }, "办件部门"),
                  _createElementVNode("th", { class: "td_center" }, "操作")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dialog.onethingDetailsDataList, (item) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.projid
                  }, [
                    _createElementVNode("td", null, _toDisplayString(item.servicename), 1),
                    _createElementVNode("td", null, _toDisplayString(item.handlestate), 1),
                    _createElementVNode("td", null, _toDisplayString(item.deptname), 1),
                    _createElementVNode("td", _hoisted_13, [
                      _createVNode(_component_el_button, {
                        size: "small",
                        type: "success",
                        onClick: ($event: any) => (showDetail1(item))
                      }, {
                        default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                          _createTextVNode("详情", -1)
                        ]))]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "title"])
    ])
  ]))
}
}

})